export const environment = {
  production: true,
  connection: {
    name: 'LH Schaerding Softline',
    host: 'https://softline-test.schaerding.rlh.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
